import ReactDOM from "react-dom/client"
import { BrowserRouter } from "react-router-dom"
import { SnackbarProvider } from "notistack"
import { HelmetProvider } from 'react-helmet-async';
import { CartProvider } from './Contexts/CartContext';
import { BookmarkProvider } from './Contexts/BookmarkProvider';
import { CategoryProvider } from './Contexts/CategoryContext';
import { LoginProvider } from './Contexts/LoginContext';
import { FloatingChatProvider } from './Contexts/FloatingChatContext';

import App from "./App"

import "./Styles/utils.css"
import "./Styles/buyer.css"
import "./Styles/seller.css"
import "./Styles/common.css"
import "./Styles/admin.css"
import "./Styles/reuseUtils.css"
import "./Styles/responsive.css"

ReactDOM.createRoot(document.getElementById("root")).render(

    <HelmetProvider>
        <BrowserRouter>
            <SnackbarProvider>
                <LoginProvider>
                    <FloatingChatProvider>
                        <CategoryProvider>
                            <CartProvider>
                                <BookmarkProvider>
                                    <App />
                                </BookmarkProvider >
                            </CartProvider>
                        </CategoryProvider>
                    </FloatingChatProvider>
                </LoginProvider>
            </SnackbarProvider>
        </BrowserRouter>
    </HelmetProvider>
)